module.exports = __webpack_public_path__ + "static/img/arroba.d88db6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arroba.png
// module id = 1443
// module chunks = 4